
import React from 'react';
import './Footer.scss'; 
import logo from './images/kuesb_logo_gray.png'; 

function Footer() {
  return (
    <footer className="Footer">

      <section className='sec-logo'>
        <img src={logo} alt="Logo" />
      </section>
    

      <section className="sec-content">
          <article className="art-content">
              <p>
                  업체명 : 주식회사 KUESB &nbsp;
                  대표이사 : 김광호 &nbsp;
                  개인정보보호책임자 : 김광호 &nbsp;
                  주소 : 강원도 원주시 봉황2길 17 2층
              </p>
          </article>

          <article className="art-section">
            <p>
              사업자번호 : 401-94-80981 &nbsp;
              통신판매업신고번호 : 1111-강원원주-1111 &nbsp;
              대표번호 : 033-735-8805
            </p>
          </article>

      </section>
    </footer>
  );
}

export default React.memo(Footer);
